import Vue from 'vue'
import axios from 'axios'
import Vuex from "vuex";

import store from "./datastore/vuexDataStore.js";

var app2 = new Vue({
  store: store,
  el: '#app2',
  data: {
    
    message: 1,
    info: null,
    testApiData: null,
    returnedData: null,
    terms: false
  },
  methods: {
    onClickChild(event) {

      this.terms = true;

      app2.message += 1;
      this.$store.commit('INCREMENT_COUNT', 2)

      axios.get('/umbraco/api/contact/testaction')
        .then(response => (this.testApiData = response))
        .catch(err => {
          console.log("axios.get: " + err);
        })
    },
    onClickChild2(event) {
      axios.post('/umbraco/api/contact/SubmitMessage',
          {
            FirstName: this.testApiData.data.Data.FirstName,
            LastName: this.testApiData.data.Data.FirstName,
            Email: this.testApiData.data.Data.Email
          })
        .then(response => (this.returnedData = response))

    }
  },
  computed: {
    isDisabled: function () {
      return !this.terms;
    }
  },
  mounted() {

    //console.log(this.$store.state.user.username);
    axios
      .get('https://api.coindesk.com/v1/bpi/currentprice.json')
      .then(response => (this.info = response))
  }
})



// WEBPACK FOOTER //
// ./src/App2.js